import React, { memo, useEffect, useState } from "react"
import Link from "next/link"
import TypeEvent from "utils/TypeEvent"
import CardBanner from "components/CardBanner"

// eslint-disable-next-line react/display-name
const MySwiper = memo(
  ({ name, description, events, id, type_block, display_type, thumbnail, thumbnail_app, color }) => {
    const [srcImage, setSrcImage] = useState(thumbnail || "/placeholder_banner_home.svg")
    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
      function handleResize() {
        if (window.innerWidth < 1024) {
          setIsMobile(true)
        } else {
          setIsMobile(false)
        }
      }

      handleResize()
      window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
    }, [])

    return (
      <div className="pr-8 max-lg:pr-4">
        {type_block === TypeEvent.BANNER && !isMobile ? (
          <div className="relative overflow-hidden rounded-3xl pointer-events-none aspect-[1577/449]">
            <img
              src={srcImage || "/placeholder_banner_home.svg"}
              alt={name}
              onError={() => setSrcImage("/placeholder_banner_home.svg")}
              className="rounded-l-3xl h-full"
            />
            <div
              className="absolute top-0 right-0 w-[80%] h-full"
              style={{
                background: `linear-gradient(to left, ${color || "#08275C"} 85%, transparent 100%)`
              }}
            ></div>
            <div className="flex flex-col justify-center absolute top-0 right-0 gap-4 max-w-[69%] h-full px-8 py-4 pointer-events-auto items-center origin-right scale-[85%] min-[1500px]:scale-90 min-[1700px]:scale-95 min-[1820px]:scale-100">
              <div className="w-full flex items-center wapper_see_more justify-between">
                <div className="flex flex-col gap-1 mr-2">
                  <span className="text-[#FAFAF9] font-semibold text-[22px] min-[1400px]:text-[26px] line-clamp-1">
                    {name}
                  </span>
                  <span className="text-sm text-secondary font-normal line-clamp-1">{description}</span>
                </div>
                <Link href={`/danh-muc/${id}`}>
                  <div
                    className={`flex items-center text-black bg-white py-1.5 px-2 rounded-lg whitespace-nowrap gap-[10px] text-xs min-[1350px]:text-sm min-[1350px]:leading-4`}
                  >
                    Xem tất cả
                  </div>
                </Link>
              </div>
              <div className="flex max-sm:flex-col gap-6 max-w-full">
                {events?.length > 0 &&
                  events?.slice(0, 2).map((item) => {
                    const { id } = item
                    return (
                      <CardBanner
                        key={id}
                        {...item}
                        display_type={display_type}
                        showTime={false}
                        type_block={type_block}
                      />
                    )
                  })}
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col gap-4 relative pb-6 rounded-xl overflow-hidden">
            <div className="relative overflow-hidden rounded-t-xl aspect-[358/134]">
              <img
                src={thumbnail_app || "/placeholder_banner_home.svg"}
                alt={name}
                onError={() => setSrcImage("/placeholder_banner_home.svg")}
                className="rounded-t-xl h-full object-cover aspect-[358/134]"
              />
              <div className="flex flex-col justify-center absolute bottom-2 right-0 w-full z-10">
                <div className="w-full flex items-center justify-between">
                  <div className="flex flex-col gap-1 mx-3 md:mx-4">
                    <span className="text-[#FAFAF9] font-semibold text-xl leading-[26px] md:text-[26px] md:leading-[30px] line-clamp-1">
                      {name}
                    </span>
                    <span className="text-xs md:text-sm text-secondary font-normal line-clamp-1">{description}</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="absolute bottom-0 right-0 h-[80%] xs:h-[75%] min-[570px]:h-[73%] sm:h-[72%] min-[690px]:h-[68%] w-full"
              style={{
                background: `linear-gradient(to top, ${color || "#08275C"} 90%, transparent 100%)`
              }}
            ></div>
            <div className={`flex max-md:flex-col gap-6 max-w-full z-10 max-lg:px-4`}>
              {events?.length > 0 &&
                events?.slice(0, 2).map((item) => {
                  const { id } = item
                  return (
                    <CardBanner
                      key={id}
                      {...item}
                      display_type={display_type}
                      showTime={false}
                      type_block={type_block}
                    />
                  )
                })}
            </div>
            <Link href={`/danh-muc/${id}`}>
              <div
                className={`flex items-center mx-4 justify-center text-black bg-white py-1.5 md:py-3 w-full rounded-lg text-xs md:text-sm md:leading-4 z-10`}
              >
                Xem tất cả
              </div>
            </Link>
          </div>
        )}
      </div>
    )
  }
)

export default MySwiper
